<template>
  <div id="app" class="d-flex flex-column h-100">
    <div v-if="mostrarBannerEntorn" class="banner-entorn alert-warning d-flex align-items-center shadow-sm">
      <div class="marquee-container flex-grow-1 overflow-hidden">
        <div class="marquee-content">
          entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves · entorn de proves
        </div>
      </div>
    </div>
    <div class="d-none d-print-block"><img src="./assets/img/logo.png" alt="Ecostudi" class="w-25" /></div>
    <nav class="navbar navbar-expand-lg navbar-light fixed-top bg-light shadow-sm" :class="{ blur: necesitaLogin }">
      <div class="container">
        <router-link exact-active-class="active text-primary font-weight-bold" class="navbar-brand" to="/"><img src="./assets/img/menu-icon.png" alt="Ecostudi" /></router-link>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto" v-show="!necesitaLogin">
            <li class="nav-item">
              <router-link exact-active-class="active text-primary font-weight-bold" to="/" class="nav-link">
                <span title="Inici" v-tooltip>
                  <i class="fa-solid fa-house"></i>
                </span>
              </router-link>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbar-consulta" role="button" data-toggle="dropdown" aria-expanded="false">Consultes</a>
              <div class="dropdown-menu mb-3" aria-labelledby="navbar-consulta">
                <router-link exact-active-class="active" class="dropdown-item" to="/disponibilitat-tecnica"><i class="fa-solid fa-hourglass-start fa-fw mr-1"></i>Disponibilitat técnica</router-link>
                <router-link exact-active-class="active" class="dropdown-item" to="/kpi-treballador"><i class="fa-solid fa-chart-pie fa-fw mr-1"></i>KPI treballador</router-link>
                <router-link exact-active-class="active" class="dropdown-item" to="/marge-projectes"><i class="fa-solid fa-arrows-left-right-to-line fa-fw mr-1"></i>Marge projectes</router-link>
                <router-link exact-active-class="active" class="dropdown-item" to="/qmi"><i class="fa-solid fa-arrow-trend-up fa-fw mr-1"></i>QMI</router-link>
                <router-link exact-active-class="active" class="dropdown-item" to="/recursos-projecte"><i class="fa-solid fa-industry fa-fw mr-1"></i>Recursos a projecte</router-link>
                <router-link exact-active-class="active" class="dropdown-item" to="/resum-hores-periode"><i class="fa-solid fa-business-time fa-fw mr-1"></i>Resum hores període</router-link>
                <router-link exact-active-class="active" class="dropdown-item" to="/projectes-oblidats"><i class="fa-solid fa-circle-exclamation fa-fw mr-1"></i>Projectes oblidats</router-link>
                <router-link exact-active-class="active" class="dropdown-item" to="/rutes"><i class="fa-solid fa-link fa-fw mr-1"></i>Rutes</router-link>
              </div>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbar-dedicacions" role="button" data-toggle="dropdown" aria-expanded="false">Dedicacions</a>
              <div class="dropdown-menu mb-3" aria-labelledby="navbar-dedicacions">
                <router-link exact-active-class="active" class="dropdown-item" to="/pd"><i class="fa-solid fa-calendar-plus fa-fw mr-1"></i>Eina PD</router-link>
                <router-link exact-active-class="active" class="dropdown-item" to="/dedicacions"><i class="fa-solid fa-table-list fa-fw mr-1"></i>Gestió dades</router-link>
                <router-link exact-active-class="active" class="dropdown-item" to="/revisor-programacio"><i class="fa-solid fa-list-check fa-fw mr-1"></i>Revisor programació</router-link>
                <router-link exact-active-class="active" class="dropdown-item" to="/historic-revisions"><i class="fa-solid fa-clock-rotate-left fa-fw mr-1"></i>Històric revisions</router-link>
              </div>
            </li>
            <li class="nav-item">
              <router-link exact-active-class="active text-primary font-weight-bold" to="/despeses" class="nav-link">Despeses</router-link>
            </li>
            <li class="nav-item">
              <router-link exact-active-class="active text-primary font-weight-bold" to="/pla-dedicacio" class="nav-link">Pla dedicació</router-link>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbar-recursos" role="button" data-toggle="dropdown" aria-expanded="false">Recursos</a>
              <div class="dropdown-menu mb-3" aria-labelledby="navbar-recursos">
                <router-link exact-active-class="active" class="dropdown-item" to="/clients"><i class="fa-solid fa-user-tie fa-fw mr-1"></i>Clients</router-link>
                <router-link exact-active-class="active" class="dropdown-item" to="/festius-empresa"><i class="fa-regular fa-calendar-check fa-fw mr-1"></i>Festius empresa</router-link>
                <router-link exact-active-class="active" class="dropdown-item" to="/projectes"><i class="fa-solid fa-archive fa-fw mr-1"></i>Projectes</router-link>
                <router-link exact-active-class="active" class="dropdown-item" to="/treballadors"><i class="fa-solid fa-user fa-fw mr-1"></i>Treballadors</router-link>
                <router-link exact-active-class="active" class="dropdown-item" to="/usuaris"><i class="fa-solid fa-user-gear fa-fw mr-1"></i>Usuaris</router-link>
                <router-link v-if="debug" exact-active-class="active" class="dropdown-item" to="/conjunts-dades"><i class="fa-solid fa-layer-group fa-fw mr-1"></i>Conjunts de dades</router-link>
                <router-link exact-active-class="active" class="dropdown-item" to="/backups"><i class="fa-solid fa-database fa-fw mr-1"></i>Còpies de seguretat</router-link>
              </div>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbar-recursos" role="button" data-toggle="dropdown" aria-expanded="false">Xifres</a>
              <div class="dropdown-menu mb-3" aria-labelledby="navbar-recursos">
                <router-link exact-active-class="active" class="dropdown-item" to="/xifres-anuals"><i class="fa-solid fa-calendar fa-fw mr-1"></i>Anuals</router-link>
                <router-link exact-active-class="active" class="dropdown-item" to="/xifres-mensuals"><i class="fa-solid fa-calendar-days fa-fw mr-1"></i>Mensuals</router-link>
              </div>
            </li>
            <li class="nav-item">
              <router-link exact-active-class="active text-primary font-weight-bold" to="/comentaris" class="nav-link">Comentaris</router-link>
            </li>
          </ul>
          <ul v-show="!necesitaLogin" class="navbar-nav ml-auto flex-row mt-3 mt-lg-0 justify-content-between align-items-center">
            <li id="changelog" class="nav-item">
              <a class="nav-link position-relative" data-toggle="popover" title="Històric de canvis" data-placement="bottom" data-html="true" :data-content="changelog" role="button">
                <i class="fa-solid fa-rss"></i>
                <span v-show="changelogCambiado" v-cloak class="badge badge-pill badge-warning position-absolute">&nbsp;</span>
              </a>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbar-usuario" role="button" data-toggle="dropdown" aria-expanded="false">Hola, {{ usuarioNombre }}</a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbar-usuario">
                <button type="button" class="dropdown-item" @click="abrirPromptIa"><i class="fa-solid fa-puzzle-piece fa-fw mr-1"></i>Prompt IA</button>
                <div class="dropdown-divider"></div>
                <button type="button" class="dropdown-item" @click="logout"><i class="fa-solid fa-right-from-bracket fa-fw mr-1"></i>Tancar la sessió</button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <router-view v-if="!necesitaLogin" class="py-5" />
    <div v-else class="container text-center blur">
      <img id="bg-logo" src="./assets/img/logo.png" alt="Ecostudi" class="img-fluid mt-5" />
    </div>
    <acceso ref="acceso" @login="login" />
    <modal ref="modalBolcat" :titulo="`Bolcat de dades: ${bolcat.titulo}`" icono="fa-solid fa-file-export" :hayLanzador="false" :clases="['modal-xl']">
      <template v-slot:body>
        <pre class="mb-0" style="overflow: visible;">{{ bolcat.contenido }}</pre>
      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-primary" @click="descargarBolcat"><i class="fa-solid fa-download mr-1"></i>Descarregar arxiu</button>
        <button type="button" class="btn btn-primary" @click="copiarBolcat"><i class="fa-solid fa-copy mr-1"></i>Copiar contingut</button>
      </template>
    </modal>
    <modal ref="modalPromptIa" titulo="Prompt IA" icono="fa-solid fa-puzzle-piece" :hayLanzador="false" :loading="cargandoPromptIa" modalId="prompt-ia" @cerrar="reiniciarPromptIa">
      <template v-slot:body>
        <div class="custom-control custom-switch mb-3">
          <input id="promptIaContinuacio" v-model="promptIaContinuacio" type="checkbox" class="custom-control-input">
          <label class="custom-control-label" for="promptIaContinuacio">Prompt de continuació</label>
        </div>
        <textarea class="form-control" rows="5" readonly aria-label="Prompt IA" :value="promptIa"></textarea>
      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-primary" :disabled="cargandoPromptIa || !promptIa" @click="copiarPromptIa"><i class="fa-solid fa-copy mr-1"></i>Copiar</button>
      </template>
    </modal>
    <footer class="footer mt-auto py-3 text-right">
      <div class="container">
        <small class="text-muted">Ecostudi ERP v{{ version }}</small>
      </div>
    </footer>
  </div>
</template>

<style lang="scss">
$theme-colors: (
  "primary": rgb(83, 144, 73),
  "secondary": rgb(25, 85, 51),
);

$table-hover-bg: #eff6ec;

.table-hover .table-light:hover,
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: $table-hover-bg !important;
}

@import "~bootstrap/scss/bootstrap";

$fa-font-path: "../node_modules/@fortawesome/fontawesome-free/webfonts" !default;
@import "node_modules/@fortawesome/fontawesome-free/scss/fontawesome";

@import "node_modules/@fortawesome/fontawesome-free/scss/brands";
@import "node_modules/@fortawesome/fontawesome-free/scss/regular";
@import "node_modules/@fortawesome/fontawesome-free/scss/solid";

[v-cloak] {
  display: none;
}

::selection {
  background: theme-color("primary");
  color: theme-color("light");
}

.v-toast__item {
  margin: 0.5rem !important;
}

.blur {
  filter: blur(1px);
}

[placeholder="Go to page"] {
  display: none;
}

#bg-logo {
  filter: grayscale(100%);
  opacity: 0.5;
}

#changelog .popover {
  min-width: calc(100% - 10px);
  box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
}

@media (min-width: 576px) {
  #changelog .popover {
    min-width: 450px;
  }
}

#changelog .popover-header {
  color: var(--dark);
}

.popover-changelog {
  overflow: auto;
  max-height: 50vh;
  padding-bottom: 1.5rem;
  padding-right: 0.75rem;
}

#changelog h1 {
  display: none;
}

#changelog h2 {
  margin-top: 1rem;
}

#changelog h1 + h2 {
  margin-top: 0;
}

#changelog img {
  max-width: 100%;
}

#changelog img {
  max-width: 100%;
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
}

#changelog:has(.popover) .nav-link {
  color: var(--dark);
}

#changelog {
  .badge {
    top: 1rem;
    transform: scale(0.5);
    left: 50%;
  }
}

[data-toggle="collapse"].desplegable-inferior {
  &[aria-expanded="true"] i {
    transform: rotate(90deg);
  }

  i {
    transition: transform 0.35s ease;
  }
}

nav.fixed-top + * {
  margin-top: 59px;
}

.banner-entorn {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1040;
  font-size: 0.7rem;
  font-weight: bold;
  text-transform: uppercase;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.marquee-container {
  white-space: nowrap;
}

.marquee-content {
  display: inline-block;
  animation: marquee 40s linear infinite;
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

.vbt-reset-button {
  display: none;
}

.vbt-refresh-button {
  border-radius: 0.25rem !important;
  margin-left: 0.5rem;
}
</style>

<script>
import Home from "@/views/Home.vue";
import Acceso from "@/components/Acceso.vue";
import { Remarkable } from 'remarkable';

const exportarDatos = (titular, filas = []) => {
  const enfiladas = filas.map(a => (Array.isArray(a) ? a : Object.values(a)).join(";"));
  const link = document.createElement("a");
  link.href = URL.createObjectURL(new Blob(["\ufeff", enfiladas.join("\n")], { type: "text/csv;charset=utf-8;" })); // Con \ufeff se arregla el bug en Excel
  link.download = `${titular}.csv`;

  link.click();
}

const formatearFecha = (str) => {
  if (isNaN(Date.parse(str))) return;

  return new Date(str).toLocaleDateString(navigator.language, { year: "numeric", month: "2-digit", day: "2-digit" });
}

const formatearVersionPromptIa = () => {
  const fecha = new Date();
  const dosDigitos = (valor) => String(valor).padStart(2, "0");

  return `${fecha.getFullYear()}${dosDigitos(fecha.getMonth() + 1)}${dosDigitos(fecha.getDate())}${dosDigitos(fecha.getHours())}${dosDigitos(fecha.getMinutes())}${dosDigitos(fecha.getSeconds())}`;
}

const recursosPromptIa = ["anuals", "clients", "comunicacions", "dedicacions", "despeses", "mensuals", "projectes", "revisions", "treballadors", "plans"];

export default {
  provide() {
    return {
      colors: {
        primary: "rgb(83, 144, 73)",
        secondary: "rgb(25, 85, 51)",
        tertiary: "rgb(252,218,1)",
        danger: "#dc3545",
        warning: "#ffc107",
        orange: "#fd7e14",
        success: "#28a745",
        softGray: "#e9ecef",
      },
      locale: process.env.VUE_APP_LOCALE,
      horasDiarias: parseFloat(process.env.VUE_APP_HORAS_DIARIAS),
      getMonth(num) {
        var objDate = new Date();
        objDate.setDate(1);
        objDate.setMonth(num);

        return objDate.toLocaleString(this.locale, { month: "long" });
      },
      exportarTabla: (titular, ref, columnasExtra = []) => {
        const filas = ref.temp_filtered_results.map(({ vbt_id, ...keepAttrs }) => keepAttrs);

        if (!filas.length) return this.$toast.open({ type: "error", position: "top", message: "No hi ha cap fila per exportar." });

        filas.unshift(Object.keys(filas[0]));

        if (columnasExtra.length) {
          columnasExtra.forEach(columna => {
            const titular = columna.shift();
            filas[0].push(titular);

            columna.forEach((celda, index) => {
              if (filas[index + 1]) {
                filas[index + 1][titular] = celda;
              }
            });
          });
        }

        exportarDatos(titular, filas);
      },
      exportarBolcat: (titular, ref, columnasExtra = []) => {
        const filas = ref.temp_filtered_results.map(({ vbt_id, ...keepAttrs }) => keepAttrs);

        if (!filas.length) return this.$toast.open({ type: "error", position: "top", message: "No hi ha cap fila per exportar." });

        filas.unshift(Object.keys(filas[0]));

        if (columnasExtra.length) {
          columnasExtra.forEach(columna => {
            const titular = columna.shift();
            filas[0].push(titular);

            columna.forEach((celda, index) => {
              if (filas[index + 1]) {
                filas[index + 1][titular] = celda;
              }
            });
          });
        }

        this.mostrarBolcat(titular, filas);
      },
      mostrarBolcat: (titulo, filas) => this.mostrarBolcat(titulo, filas),
      exportarDatos,
      actionsExportar: [
        {
          btn_text: /*html*/`<i class="fa-solid fa-file-export"></i><div class="spinner-border spinner-border-sm d-none" role="status"></div> Exportar`,
          event_name: "exportarBolcat",
          class: "btn btn-secondary exportar-bolcat",
        },
      ],
      calcularDiasHabiles(curDate, endDate) {
        let diasDisponibles = 0;

        while (curDate <= endDate) {
          const dayOfWeek = curDate.getDay();
          if (dayOfWeek !== 0 && dayOfWeek !== 6) diasDisponibles++;
          curDate.setDate(curDate.getDate() + 1);
        }

        return diasDisponibles;
      },
      formatearDecimales(valor, maximumFractionDigits = 2) {
        return parseFloat(valor ?? 0).toLocaleString(undefined, { maximumFractionDigits });
      },
      capitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      getTonoRandom() {
        return Math.floor(Math.random() * (235 - 52 + 1) + 52);
      },
      rangoInicioLTM: new Date(new Date().getFullYear() - 1, new Date().getMonth(), 2).toISOString().split("T")[0],
      rangoFinLTM: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split("T")[0],
      rangoInicioYTD: new Date().getFullYear() + "-01-01",
      rangoFinYTD: new Date().toISOString().split("T")[0],
      rangoInicioLM: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split("T")[0],
      rangoFinLM: new Date().toISOString().split("T")[0],
      calcularFranja(inicio, final) {
        var partesInicio = inicio.split(".");
        var partesFinal = final.split(".");

        var horaInicio = new Date();
        var horaFinal = new Date();

        horaInicio.setHours(parseInt(partesInicio[0]), parseInt(partesInicio[1]));
        horaFinal.setHours(parseInt(partesFinal[0]), parseInt(partesFinal[1]));

        return {
          horaInicio: horaInicio.toLocaleTimeString(navigator.language, { hour: "2-digit", minute: "2-digit" }),
          horaFinal: horaFinal.toLocaleTimeString(navigator.language, { hour: "2-digit", minute: "2-digit" }),
          diferencia: parseFloat(((horaFinal - horaInicio) / (3600 * 1000)).toFixed(2)),
        };
      },
      comprobarFranjaValida(franja) {
        return franja > 0 && ((franja - parseInt(franja)) * 100) % 25 === 0;
      },
      exportarFilasExcel(table) {
        const uri = 'data:application/vnd.ms-excel;base64,';
        const template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><?xml version="1.0" encoding="UTF-8" standalone="yes"?><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name></x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
        const base64 = (s) => window.btoa(unescape(encodeURIComponent(s)));
        const format = (s, c) => s.replace(/{(\w+)}/g, (m, p) => c[p]);

        window.location.href = uri + base64(format(template, { table }));
      },
      formatearFecha,
      formatearFechaHora(str) {
        const fecha = formatearFecha(str);

        return `${fecha} ${new Date(str).toLocaleTimeString("ca-ES", { hour: 'numeric', minute: 'numeric' })}`;
      },
      formatearMes(mesAnyo) {
        const objDate = new Date(mesAnyo);

        return objDate.toLocaleString("ca-ES", { month: "long", year: "numeric" });
      },
    };
  },
  components: {
    home: Home,
    acceso: Acceso,
  },
  data() {
    return {
      debug: Boolean(parseInt(process.env.VUE_APP_DEBUG)),
      version: process.env.VUE_APP_VERSION,
      dominio: process.env.VUE_APP_DOMAIN,
      refreshing: false,
      serviceWorker: null,
      usuarioId: null,
      usuarioNombre: null,
      usuarioRol: null,
      usuarioTrabajador: null,
      localstorages: ["usuarioId", "usuarioNombre", "usuarioRol", "usuarioTrabajador"],
      cargandoPromptIa: false,
      claudeToken: "",
      promptIaContinuacio: false,
      versionPromptIa: "",
      promptIaInterval: null,
      changelog: "",
      changelogUltimoGuardado: localStorage.getItem("changelog"),
      changelogCambiado: false,
      bolcat: {
        titulo: "",
        contenido: "",
        filas: [],
      },
    };
  },
  computed: {
    promptIa() {
      if (!this.claudeToken || !this.versionPromptIa) return "";

      const endpoints = recursosPromptIa
        .map((recurso) => `- https://erp.ecostudi.com/api/${recurso}?token=${this.claudeToken}&v=${this.versionPromptIa}`)
        .join("\n");

      if (this.promptIaContinuacio) {
        return `Els endpoints actualitzats són:\n\n${endpoints}`;
      }

      return [
        "Treballes com a assistent de suport per a l'ERP de l'empresa Ecostudi. Pots accedir a internet i fer peticions HTTP GET per consultar els endpoints de la seva API quan sigui necessari.",
        "",
        "Els endpoints disponibles són:",
        "",
        endpoints,
        "",
        "Tots aquests endpoints retornen files d'informació en format JSON.",
        "",
        "**Comportament i límits dels endpoints:**",
        "",
        "- Les consultes per defecte retornen dades generals, no dades filtrades pel propietari del token. El token de Claude no crea una sessió PHP.",
        "- Sense filtres, `anuals`, `clients`, `comunicacions`, `dedicacions`, `despeses`, `mensuals`, `projectes`, `revisions` i `treballadors` retornen els seus llistats generals. `plans` retorna un resum agregat per treballador, any i mes; per obtenir el detall d'un treballador, indica `trabajador=<id>`.",
        "- `dedicacions` i `despeses` accepten `fecha_inicio` i `fecha_fin` en format `YYYY-MM-DD`. Es poden enviar les dues dates o només una per limitar un extrem del període; les dates dels extrems s'inclouen. Sense dates, es consulta tot el període disponible.",
        "- `dedicacions` retorna un error 400 si la consulta supera 17.000 files; `despeses`, si supera 15.000. Si passa, repeteix la consulta en períodes més petits amb `fecha_inicio` i `fecha_fin`.",
        "- A `projectes`, les dates afecten les dades de previsió quan s'utilitza el mode `prevision` amb `id`; no limiten el llistat normal de projectes.",
        "- `mensuals?qmi=<valor>` retorna una sèrie de 12 mesos. `clients?activos` i `treballadors?activos` limiten els resultats als registres actius; `treballadors?planificadors` retorna els treballadors actius que planifiquen.",
        "- En els modes personals de `dedicacions`, `plans` i `projectes`, indica un identificador de treballador explícit (`trabajador` o `trabajador_escogido`, segons el mode). No assumeixis que el token proporciona la sessió de l'usuari.",
        "",
        "**Instruccions de funcionament:**",
        "",
        "1. Utilitza els endpoints com a font de dades per respondre les meves preguntes sobre l'ERP d'Ecostudi.",
        "2. Analitza els camps, els tipus de dades i les possibles relacions entre recursos quan sigui necessari. No inventis informació ni relacions que no puguis verificar.",
        "3. Si una resposta és massa extensa per processar-la íntegrament, treballa amb les dades disponibles i indica'n les limitacions.",
        "4. Si no pots accedir a un endpoint o verificar una dada, indica-ho clarament.",
        "5. A la primera resposta, calcula a partir de l'hora actual quan haurà passat una hora i informa'm de l'hora orientativa en què hauré de tornar a proporcionar els endpoints actualitzats.",
      ].join("\n");
    },
    necesitaLogin: function () {
      return this.$auth == false;
    },
    mostrarBannerEntorn() {
      return this.debug && localStorage.getItem("ocultarBannerEntorn") !== "true";
    },
  },
  created() {
    let that = this;

    this.localstorages.forEach(function (item) {
      that[item] = localStorage.getItem(item);
    });

    document.addEventListener("swUpdated", this.updateAvailable, { once: true });
    document.addEventListener("swRegistered", this.swRegistered, { once: true });

    // Previene multiples refrescos
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (this.refreshing) {
          return;
        }

        this.refreshing = true;
        this.$toast.open({ type: "warning", position: "top", duration: 0, message: `Actualitzant l'app, si us plau espera un moment.` });
        window.location.reload();
      });
    }
  },
  mounted() {
    this.actualizarVersionPromptIa();
    this.promptIaInterval = setInterval(this.actualizarVersionPromptIa, 60000);

    const md = new Remarkable();

    fetch("CHANGELOG.md")
      .then((response) => {
        if (new Date(response.headers.get("Last-Modified")) >= new Date(this.changelogUltimoGuardado)) {
          this.changelogUltimoGuardado = response.headers.get("Last-Modified");
        }

        return response.text();
      })
      .then((text) => {
        const rendered = md.render(text);
        this.changelog = /*html*/`<div class="popover-changelog">${rendered}</div>`;

        $('#changelog [data-toggle="popover"]')
          .popover({
            container: "#changelog",
            template: /*html*/
              `<div class="popover" role="tooltip">
                            <div class="arrow"></div>
                            <h3 class="popover-header"></h3>
                            <span data-dismiss="popover" class="text-dark py-2 position-absolute pr-3" role="button" tabindex="0" style="top: 0; right: 0;">
                                <i class="fas fa-times"></i>
                            </span>
                            <div class="popover-body"></div>
                        </div>`,
            sanitize: false,
          })
          .on("inserted.bs.popover", () => $('#changelog [data-dismiss="popover"]').one("click", () => $('#changelog [data-toggle="popover"]').popover('hide')))
          .on("shown.bs.popover", () => this.changelogCambiado = false);
      });
  },
  beforeDestroy() {
    clearInterval(this.promptIaInterval);
  },
  methods: {
    swSubscribed(event) { },
    swRegistered(event) {
      this.serviceWorker = event.detail;

      this.serviceWorker.pushManager.getSubscription().then(function (subscription) {
        if (subscription) {
        }
      });
    },
    updateAvailable(event) {
      let registration = event.detail;

      if (!registration || !registration.waiting) {
        return;
      }

      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    },
    login(usuario) {
      this.$auth = true;
      this.usuarioId = usuario.id;
      this.usuarioNombre = usuario.nom;
      this.usuarioRol = usuario.rol;
      this.usuarioTrabajador = usuario.id_treballador;

      localStorage.setItem("usuarioId", this.usuarioId);
      localStorage.setItem("usuarioTrabajador", this.usuarioTrabajador);
      localStorage.setItem("usuarioNombre", this.usuarioNombre);
      localStorage.setItem("usuarioRol", this.usuarioRol);
    },
    logout() {
      this.$http.post("api/usuaris", { logout: null }).then(() => {
        if (this.$router.currentRoute.fullPath != "/") {
          this.$router.push("/");
        }

        this.$auth = false;

        this.localstorages.forEach((item) => {
          this[item] = null;
          localStorage.removeItem(item);
        });
      });
    },
    actualizarVersionPromptIa() {
      this.versionPromptIa = formatearVersionPromptIa();
    },
    reiniciarPromptIa() {
      this.promptIaContinuacio = false;
    },
    abrirPromptIa() {
      this.claudeToken = "";
      this.reiniciarPromptIa();
      this.cargandoPromptIa = true;
      this.actualizarVersionPromptIa();
      this.$refs.modalPromptIa.abrir();

      this.$http.get("api/usuaris?claude_token").then(({ data }) => {
        this.claudeToken = data.token;
      }).catch(() => {
        this.$refs.modalPromptIa.cerrar();
      }).finally(() => {
        this.cargandoPromptIa = false;
      });
    },
    copiarPromptIa() {
      navigator.clipboard.writeText(this.promptIa).then(() => {
        this.$toast.open({ position: "top", message: "Prompt copiat al porta-retalls." });
      });
    },
    mostrarBolcat(titulo, filas) {
      const enfiladas = filas.map(a => (Array.isArray(a) ? a : Object.values(a)).join(";"));
      this.bolcat.titulo = titulo;
      this.bolcat.contenido = "\ufeff" + enfiladas.join("\n");
      this.bolcat.filas = filas;
      this.$refs.modalBolcat.abrir();
    },
    descargarBolcat() {
      exportarDatos(this.bolcat.titulo, this.bolcat.filas);
    },
    copiarBolcat() {
      navigator.clipboard.writeText(this.bolcat.contenido).then(() => {
        this.$toast.open({ position: "top", message: "Contingut copiat al porta-retalls." });
      });
    },
  },
  watch: {
    $auth: function (value) {
      if (value) {
        this.$refs.acceso.cerrarLogin();
      } else {
        this.$toast.clear();
        this.$toast.open({ type: "warning", position: "top", duration: 0, message: `Si us plau, inicia sessió per poder continuar.` });

        this.$refs.acceso.abrirLogin();
      }
    },
    changelogUltimoGuardado() {
      this.changelogCambiado = true;
    },
    changelogCambiado(value) {
      if (!value) {
        localStorage.setItem("changelog", this.changelogUltimoGuardado);
      }
    },
  },
};
</script>
